/* ==========================================================================
   Overview tab slideshow — arrows, bar dots, swipe, optional autoplay
   ========================================================================== */
(function () {
  'use strict';

  var CHEVRON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 ' +
    'L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"/></svg>';

  /* ------------------------------------------------- build from description
     Merchants paste images and text straight into the product Description.
     Rather than making them re-enter everything as blocks, lift those images
     out of the rendered description and stack them into the same slider. */
  function buildFromDescription(scope) {
    (scope || document).querySelectorAll('[data-ov-description]').forEach(function (desc) {
      if (desc.dataset.kkOvBuilt === 'true') return;
      desc.dataset.kkOvBuilt = 'true';

      var mode = desc.getAttribute('data-ov-mode');
      if (mode !== 'images' && mode !== 'groups') return;

      var host = desc.parentNode.querySelector('[data-ov-mount]');
      if (!host) return;

      var slides = [];

      if (mode === 'images') {
        // Every image becomes its own slide; the prose stays where it was.
        Array.prototype.slice.call(desc.querySelectorAll('img')).forEach(function (img) {
          var holder = img.closest('p, figure, div') || img;
          slides.push({ img: img, caption: null });
          // Drop the wrapper too if the image was all it held
          if (holder !== img && holder.textContent.trim() === '' && holder.parentNode === desc) {
            holder.parentNode.removeChild(holder);
          }
        });
      } else {
        // Each image plus the copy that follows it, up to the next image.
        var nodes = Array.prototype.slice.call(desc.childNodes);
        var current = null;

        nodes.forEach(function (node) {
          var img = node.nodeType === 1
            ? (node.tagName === 'IMG' ? node : node.querySelector('img'))
            : null;

          if (img) {
            current = { img: img, caption: document.createElement('div') };
            slides.push(current);
            if (node.parentNode === desc) desc.removeChild(node);
          } else if (current && node.nodeType === 1) {
            current.caption.appendChild(node);
          }
        });
      }

      if (!slides.length) return;

      var root = document.createElement('div');
      root.className = 'ovslider';
      root.setAttribute('data-ovslider', '');
      ['loop', 'autoplay', 'interval'].forEach(function (k) {
        root.setAttribute('data-' + k, desc.getAttribute('data-' + k) || '');
      });
      root.style.setProperty('--ov-ratio', desc.getAttribute('data-ratio') || '2.5 / 1');
      root.style.setProperty('--ov-ratio-mobile', desc.getAttribute('data-ratio-mobile') || '4 / 3');

      var stacked = mode === 'groups';
      var viewport = document.createElement('div');
      viewport.className = 'ovslider__viewport';
      var track = document.createElement('div');
      track.className = 'ovslider__track' + (stacked ? ' ovslider__track--stacked' : '');
      track.setAttribute('data-ov-track', '');

      slides.forEach(function (s) {
        var slide = document.createElement('div');
        slide.className = 'ovslider__slide' + (stacked ? ' ovslider__slide--stacked' : '');
        slide.setAttribute('data-ov-slide', '');

        var media = document.createElement('div');
        media.className = 'ovslider__media';
        media.appendChild(s.img); // moved, so srcset/sizes/loading survive
        slide.appendChild(media);

        if (s.caption && s.caption.childNodes.length) {
          s.caption.className = 'ovslider__caption rte';
          slide.appendChild(s.caption);
        }

        track.appendChild(slide);
      });

      viewport.appendChild(track);
      root.appendChild(viewport);

      if (slides.length > 1) {
        ['prev', 'next'].forEach(function (dir) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ovslider__arrow ovslider__arrow--' + dir;
          btn.setAttribute('data-ov-' + dir, '');
          btn.setAttribute('aria-label', dir === 'prev' ? 'Previous slide' : 'Next slide');
          btn.innerHTML = CHEVRON;
          root.appendChild(btn);
        });

        var dots = document.createElement('div');
        dots.className = 'ovslider__dots';
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ovslider__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('data-ov-dot', '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dots.appendChild(dot);
        });
        root.appendChild(dots);
      }

      host.appendChild(root);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ovslider]').forEach(function (root) {
      if (root.dataset.kkOvReady === 'true') return;
      root.dataset.kkOvReady = 'true';

      var track = root.querySelector('[data-ov-track]');
      var viewport = root.querySelector('.ovslider__viewport');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ov-slide]'));
      if (!track || slides.length === 0) return;

      // Arrows sit inside the viewport so they centre on the image, not on the
      // image plus the dots underneath it.
      if (viewport) {
        root.querySelectorAll('[data-ov-prev], [data-ov-next]').forEach(function (btn) {
          viewport.appendChild(btn);
        });
      }

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ov-dot]'));
      var prev = root.querySelector('[data-ov-prev]');
      var next = root.querySelector('[data-ov-next]');
      var loop = root.getAttribute('data-loop') === 'true';
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      var total = slides.length;
      var index = 0;
      var timer = null;

      // Match the viewport to the slide on screen, otherwise the tallest image
      // in the set dictates the height and short ones leave a gap below.
      function fitHeight() {
        if (!viewport) return;
        var active = slides[index];
        if (!active) return;
        var h = active.getBoundingClientRect().height;
        if (h > 0) viewport.style.height = h + 'px';
      }

      slides.forEach(function (slide) {
        slide.querySelectorAll('img').forEach(function (img) {
          if (img.complete) return;
          img.addEventListener('load', fitHeight);
          img.addEventListener('error', fitHeight);
        });
      });

      var fitTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(fitTimer);
        fitTimer = setTimeout(fitHeight, 120);
      });

      function render() {
        track.style.transform = 'translateX(' + -index * 100 + '%)';
        fitHeight();

        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-current', i === index ? 'true' : 'false');
        });

        slides.forEach(function (s, i) {
          // Keep off-screen slides out of the tab order
          s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });

        if (!loop) {
          if (prev) prev.disabled = index === 0;
          if (next) next.disabled = index === total - 1;
        }
      }

      function goTo(i) {
        if (loop) {
          index = (i + total) % total;
        } else {
          index = Math.min(Math.max(i, 0), total - 1);
        }
        render();
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); restart(); });

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { goTo(i); restart(); });
      });

      /* ---- touch swipe ---- */
      var startX = null;
      var startY = null;

      root.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      root.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        // Ignore mostly-vertical gestures so page scrolling still works
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          goTo(index + (dx < 0 ? 1 : -1));
          restart();
        }
        startX = null;
        startY = null;
      }, { passive: true });

      /* ---- autoplay ---- */
      function restart() {
        clearInterval(timer);
        if (!autoplay || total < 2) return;
        timer = setInterval(function () { goTo(index + 1); }, interval);
      }

      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', restart);

      render();
      restart();

      // A slider inside a hidden tab measures nothing until shown; re-assert
      // the transform whenever its tab becomes active.
      var panel = root.closest('[data-kk-panel]');
      if (panel) {
        new MutationObserver(function () {
          if (!panel.hidden) render();
        }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
      }
    });
  }

  function boot(scope) {
    buildFromDescription(scope);
    init(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    // Jump to the slide the merchant clicked in the theme editor
    var slide = e.target.closest ? e.target.closest('[data-ov-slide]') : null;
    if (!slide) return;
    var root = slide.closest('[data-ovslider]');
    if (!root) return;
    var all = Array.prototype.slice.call(root.querySelectorAll('[data-ov-slide]'));
    var dot = root.querySelectorAll('[data-ov-dot]')[all.indexOf(slide)];
    if (dot) dot.click();
  });
})();
